import React from 'react';
import { Link } from 'react-router-dom';

import './styles.css';

export default function PageLink(props) {
    return (
        props.external ?
            <a href={props.to} target='_blank' rel='noreferrer'
                className={'main-menu-link' + (props.selected ? ' selected' : '')}
            >
                {props.icon}
                <p className='main-menu-link-text'>{props.text}</p>
            </a>
            :
            <Link onClick={props.onClick} to={props.to} className={'main-menu-link' + (props.selected ? ' selected' : '')}>
                {props.icon}
                <p className='main-menu-link-text'>{props.text}</p>
            </Link>
    )
}
